import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useUnlinkAccountant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/integrations/accountant/unlink', { method: 'POST' });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return { ...user, accountant: null };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
